module.exports = __webpack_public_path__ + "img/trainersignup-01.50d27ab5.png";